<template>
  <div>
    <div class="jumbotron container-fluid" style="border-radius: 0px">
      <div class="container" style="margin-top: -20px">
        <div class="row">
          <div class="col" :style="rtl ? 'text-align: right;' : ''">
            <img src="@/assets/kekw.png" style="width: 60px" /><router-link
              id="router-link"
              :to="{ name: 'Today' }"
              ><img src="@/assets/zuniLogo.svg" style="width: 130px"
            /></router-link>
          </div>
          <b-button
            v-b-modal.modal-search
            style="
              background: #212225;
              border-radius: 2px;
              border: none;
              height: 39px;
              margin-top: 7.5px;
            "
            ><img
              src="@/assets/search.png"
              style="width: 16px; height: 16px"
              alt=""
          /></b-button>
          <router-link
            id="router-link"
            style="color: whitesmoke"
            :to="{ name: 'Faq' }"
            ><b-button
              style="
                background: #212225;
                border-radius: 2px;
                border: none;
                height: 39px;
                margin-top: 7.5px;
                margin-left: 8px;
                font-size: 13px;
                letter-spacing: 1px;
              "
              >FAQ
            </b-button></router-link
          >
          <div>
            <b-dropdown
              id="dropdown-1"
              style="background: #212225; border-radius: 2px"
              variant="none"
              no-caret
              class="m-md-2 b3"
            >
              <template #button-content>
                <div v-if="cookiesObject.token">
                  <img
                    src="@/assets/uk.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-if="selLanguage.code == 'en'"
                  />
                  <img
                    src="@/assets/russia.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="selLanguage.code == 'ru'"
                  />
                  <img
                    src="@/assets/azerbaijan.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="selLanguage.code == 'aze'"
                  />
                  <img
                    src="@/assets/georgia.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="selLanguage.code == 'ka'"
                  />
                  <img
                    src="@/assets/france.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="selLanguage.code == 'fr'"
                  />
                  <img
                    src="@/assets/arab.png"
                    style="
                      width: 25px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="selLanguage.code == 'ar'"
                  />
                  <img
                    src="@/assets/flag.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else
                  />
                  <span style="color: lightgrey; font-size: 14px"
                    >{{ selLanguage.code }}
                    <img
                      src="@/assets/ardown.png"
                      style="width: 10px; margin-left: 7px; margin-bottom: 2px"
                      alt=""
                  /></span>
                </div>
                <div v-else>
                  <img
                    src="@/assets/uk.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-if="cookiesObject.lang == 'en'"
                  />
                  <img
                    src="@/assets/russia.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="cookiesObject.lang == 'ru'"
                  />
                  <img
                    src="@/assets/azerbaijan.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="cookiesObject.lang == 'aze'"
                  />
                  <img
                    src="@/assets/georgia.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="cookiesObject.lang == 'ka'"
                  />
                  <img
                    src="@/assets/france.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="cookiesObject.lang == 'fr'"
                  />
                  <img
                    src="@/assets/arab.png"
                    style="
                      width: 25px;
                      margin-right: 5px;
                      margin-left: 0px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else-if="cookiesObject.lang == 'ar'"
                  />
                  <img
                    src="@/assets/flag.png"
                    style="
                      width: 15px;
                      margin-right: 5px;
                      margin-left: 5px;
                      margin-bottom: 2px;
                    "
                    alt=""
                    v-else
                  />
                  <span style="color: lightgrey; font-size: 14px"
                    >{{ cookiesObject.lang }}
                    <img
                      src="@/assets/ardown.png"
                      style="width: 10px; margin-left: 7px; margin-bottom: 2px"
                      alt=""
                  /></span>
                </div>
              </template>
              <b-dropdown-item
                v-for="language in languages"
                :key="language.id"
                @click="changeLang(language.code, language.id)"
              >
                <img
                  src="@/assets/uk.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-if="language.code == 'en'"
                />
                <img
                  src="@/assets/russia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="language.code == 'ru'"
                />
                <img
                  src="@/assets/azerbaijan.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="language.code == 'aze'"
                />
                <img
                  src="@/assets/georgia.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="language.code == 'ka'"
                />
                <img
                  src="@/assets/france.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="language.code == 'fr'"
                />
                <img
                  src="@/assets/arab.png"
                  style="
                    width: 25px;
                    margin-right: 5px;
                    margin-left: 0px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else-if="language.code == 'ar'"
                />
                <img
                  src="@/assets/flag.png"
                  style="
                    width: 15px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                  v-else
                />
                <span class="ddHov" style="color: lightgrey; font-size: 14px">
                  {{ language.name }}
                </span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <!-- <b-button class="b1" v-if="cookiesObject.token" style="font-size: 14px; border-radius: 2px; background: #212225; border: none; color: lightgrey; height: 39px; margin-top: 7.5px; cursor: default;"><img src="@/assets/wallet.svg" style="width: 20px; margin-right: 5px; margin-left: 5px; margin-bottom: 2px;" alt="">{{ $t('LanguageEn.balance') }}: {{balance}}</b-button> -->
          <div v-if="cookiesObject.token" style="margin-right: 10px">
            <b-dropdown
              id="dropdown-1"
              class="m-md-2 b2"
              no-caret
              variant="none"
              style="
                background: #212225;
                border-radius: 2px;
                color: white;
                height: 39px;
              "
            >
              <template #button-content>
                <img
                  src="@/assets/profile.svg"
                  style="
                    width: 24px;
                    margin-right: 5px;
                    margin-left: 5px;
                    margin-bottom: 2px;
                  "
                  alt=""
                /><span style="color: lightgrey; font-size: 14px"
                  >{{ cookiesObject.number }}
                  <img
                    src="@/assets/ardown.png"
                    style="width: 10px; margin-left: 7px; margin-bottom: 2px"
                    alt=""
                /></span>
              </template>
              <b-dropdown-item
                @click.native.capture.stop
                style="font-size: 14px"
              >
                Notifications
                <label
                  :class="{ active: isActive }"
                  class="toggle__button"
                  style="margin-top: 5px"
                >
                  <input
                    v-on:change="setNot()"
                    type="checkbox"
                    v-model="checkedValue"
                  />
                  <span class="toggle__switch"></span>
                </label>
              </b-dropdown-item>
              <b-dropdown-item to="/PredictionsList" style="font-size: 14px"
                ><img src="@/assets/guessList.svg" style="width: 24px" alt="" />
                {{ $t("LanguageEn.myGuesses") }}</b-dropdown-item
              >
              <b-dropdown-item to="/Leaderboard" style="font-size: 14px"
                ><img
                  src="@/assets/leaderboard.svg"
                  style="width: 24px"
                  alt=""
                />
                {{ $t("LanguageEn.leaderboard") }}</b-dropdown-item
              >
              <b-dropdown-item><LoginP /></b-dropdown-item>
            </b-dropdown>
          </div>
          <LoginP v-else style="margin-right: 10px" />
        </div>
      </div>
    </div>

    <b-modal
      id="modal-prevent-closing"
      ref="modal-prevent-closing"
      @hide="handleOk"
      hide-footer
      hide-header
      body-class="webOtp1"
    >
      <div style="padding: 20px 5px">
        <p style="color: white">Zunisport</p>
        <p style="color: white">{{ $t("LanguageEn.activation") }}</p>
      </div>
      <button
        style="float: left"
        type="button"
        class="loginButton1 btn btn-primary"
        data-toggle="modal"
        @click="logout()"
      >
        {{ $t("LanguageEn.logout") }}
      </button>
      <button
        style="float: right"
        type="button"
        class="loginButton btn btn-primary"
        data-toggle="modal"
        @click="activate()"
      >
        {{ $t("LanguageEn.actButton") }}
      </button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginP from "../components/RightColumn/LoginP";

export default {
  name: "Showcase",
  data() {
    return {
      cookiesObject: "",
      selected: "",
      languages: [],
      selLanguage: "",
      namel: "",
      res: "",
      error: "",
      currentState: false,
    };
  },
  async mounted() {
    var cookiesObject = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce(
        (accumulator, [key, value]) => ({
          ...accumulator,
          [key.trim()]: decodeURIComponent(value),
        }),
        {}
      );
    this.cookiesObject = cookiesObject;

    try {
      this.$messaging?.getToken({
        vapidKey:
          "BJ-0sELQgU4GjF7r1fCof4brbAB4H2z7Qlsrwzz1pfgjqGySSYuXWudoxOjD89vwXcixSFzZ1uxqXew7qWvHyws",
      });

      if (cookiesObject.token) {
        this.getToken1();
      }
    } catch (error) {
      console.log(error);
    }

    // this.$messaging.getToken({ vapidKey: "BJ-0sELQgU4GjF7r1fCof4brbAB4H2z7Qlsrwzz1pfgjqGySSYuXWudoxOjD89vwXcixSFzZ1uxqXew7qWvHyws" });
    // this.getToken1();
    if (cookiesObject.token) {
      this.getBalance1();
      this.getBalance();

      // this.getToken();
    }

    if (cookiesObject.token) {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq + "/user/me?token=" + cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.code == 201) {
            location.href = result.redirect;
          }

          if (result.code == 202) {
            this.$refs["modal-prevent-closing"].show();
          }

          this.$i18n.locale = result.user.language.code;
          document.cookie =
            "lang =" +
            result.user.language.code +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          document.cookie =
            "langId =" +
            result.user.language.id +
            ";expires = Thu, 01 Jan 2040 00:00:00 GMT;";

          if (result.user.notification == 1) {
            this.currentState = true;
          } else {
            this.currentState = false;
          }
        })
        .catch((error) => console.log("error", error));
    }

    if (cookiesObject.token) {
      const res = await fetch(
        this.httpReq + "/general/appData?token=" + this.cookiesObject.token,
        { method: "get" }
      );
      const data = await res.json();
      const languages = data.portal.languages;
      this.languages = languages;
    } else {
      const res = await fetch(
        this.httpReq +
          "/general/appData?portalId=" +
          (this.cookiesObject.portalId ? this.cookiesObject.portalId : 0),
        { method: "get" }
      );
      const data = await res.json();
      const languages = data.portal.languages;
      this.languages = languages;
    }

    if (!this.cookiesObject.token) {
      this.$i18n.locale = this.cookiesObject.lang;
    }
    // if (this.cookiesObject.lang != '') {
    // this.$i18n.locale = this.cookiesObject.lang;
    // }

    // var chStatus = await fetch(this.httpReq + '/user/me?token=' + this.cookiesObject.token);
    // var chData = await chStatus.json();
    // var chStatusCode = chData.code;

    this.$forceUpdate();
  },

  methods: {
    ...mapActions(["setLang", "getBalance"]),
    setNot() {
      var requestOptions = {
        method: "PUT",
        redirect: "follow",
      };

      if (this.currentState == true) {
        var sent = 1;
      } else {
        sent = 0;
      }

      fetch(
        "https://sportapi.zuniac.com/user/notification?status=" +
          sent +
          "&token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => console.log(result.message))
        .catch((error) => console.log("error", error));
    },
    getToken1() {
      this.$messaging
        .getToken({
          vapidKey:
            "BJ-0sELQgU4GjF7r1fCof4brbAB4H2z7Qlsrwzz1pfgjqGySSYuXWudoxOjD89vwXcixSFzZ1uxqXew7qWvHyws",
        })
        .then((currentToken) => {
          if (currentToken) {
            var myHeaders = new Headers();
            myHeaders.append(
              "Cookie",
              "__cfduid=df2a91fbe41d157df37eda10912805fd81618232247"
            );

            var requestOptions = {
              method: "PUT",
              headers: myHeaders,
              redirect: "follow",
            };

            fetch(
              "https://sportapi.zuniac.com/user/fcm?fcmToken=" +
                currentToken +
                "&token=" +
                this.cookiesObject.token,
              requestOptions
            )
              .then((response) => response.json())
              .then((result) => {
                this.res = result;
                // console.log(currentToken)
                // console.log(1,result)
              })
              .catch((error) => console.log("error", error));
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          this.error = err;
        });
    },
    logout() {
      document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "langId = 1; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "lang = en; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      location.assign("/");
    },
    activate() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=df2a91fbe41d157df37eda10912805fd81618232247"
      );

      var requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        "https://sportapi.zuniac.com/user/activate?token=" +
          this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.log(result);

          setTimeout(function some() {
            location.assign("/");
          }, 150);
        })
        .catch((error) => console.log("error", error));
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      // this.handleSubmit()
    },
    changeLang(value, value1) {
      this.setLang(value, value1);
      if (this.lang != undefined) {
        this.$i18n.locale = this.cookiesObject.lang;
        document.cookie = "lang =" + value;
        document.cookie = "langId =" + value1;

        if (this.cookiesObject.token) {
          var myHeaders = new Headers();
          myHeaders.append(
            "Cookie",
            "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234"
          );

          var requestOptions = {
            method: "PUT",
            headers: myHeaders,
            redirect: "follow",
          };

          fetch(
            this.httpReq +
              "/user/language?languageId=" +
              (value1 ? value1 : 0) +
              "&token=" +
              this.cookiesObject.token,
            requestOptions
          )
            .then((response) => response.text())
            .then((result) => console.log(result))
            .catch((error) => console.log("error", error))
            .then(
              setTimeout(function some() {
                location.reload();
              }, 500)
            );
        } else {
          location.reload();
        }
      }
    },
    getBalance1() {
      var myHeaders = new Headers();
      myHeaders.append(
        "Cookie",
        "__cfduid=daa11664c49161bf93cd02dbd6c4fb8131611146765"
      );

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(
        this.httpReq + "/user/me?token=" + this.cookiesObject.token,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // this.balance = result.user.score;
          // document.cookie = 'balance =' + result.user.score;
          this.selLanguage = result.user.language;
        })
        .catch((error) => console.log("error", error));
    },
  },
  watch: {},

  computed: {
    ...mapGetters(["lang", "httpReq", "balance", "rtl"]),
    isActive() {
      return this.currentState;
    },
    checkedValue: {
      get() {
        return this.currentState;
      },
      set(newValue) {
        this.currentState = newValue;
      },
    },
  },

  props: {},
  components: {
    LoginP,
  },
};
</script>

<style scoped>
.jumbotron {
  background: #1a1a1d !important;
  height: 120px !important;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
}

#router-link,
#router-link:visited,
#router-link:active,
#router-link:focus {
  text-decoration: none;
  border: 0;
  outline: 0;
}

.loginButton {
  background: #1c5e20;
  border: solid #1c5e20;
  border-width: 2px;
  margin-right: 10px;
  color: white;
  float: right;
  border-radius: 2px;
  height: 39px;
  margin-top: -8px;
}
.loginButton1 {
  background: transparent;
  border: solid #1c5e20;
  border-width: 2px;
  margin-right: 10px;
  color: white;
  float: right;
  border-radius: 2px;
  height: 39px;
  margin-top: -8px;
}
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
}
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  border-radius: 6px;
  width: 40px;
  background: #bfcbd9;
  box-shadow: inset 0 0 1px #bfcbd9;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
}
.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  left: 0;
  top: -3px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
}
.toggle__button .toggle__switch::after {
  background: #4d4d4d;
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #4d4d4d;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.active .toggle__switch {
  background: #46944a;
  box-shadow: inset 0 0 1px #bfcbd9;
}
.active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(40px - 18px);
}
.active .toggle__switch::after {
  left: 23px;
  background: #43a047;
}

.ddHov:hover {
  text-decoration: underline;
}
</style>
<style>
.b2 .dropdown-menu {
  background: rgba(56, 57, 57, 1) !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
}
.b2 .dropdown-item {
  color: white;
}
.b2 .dropdown-item:hover {
  background: rgba(56, 57, 57) !important;
}
.b3 .dropdown-menu {
  background: rgba(56, 57, 57, 1) !important;
  color: white !important;
  padding-top: 0px;
  padding-bottom: 0px;
}
.b3:hover {
  background: #383939 !important;
  color: white !important;
}
.b2:hover {
  background: #383939 !important;
  color: white !important;
}
.b3 .dropdown-item {
  color: white;
}
.b3 .dropdown-item:hover {
  background: rgba(56, 57, 57, 0.8) !important;
}
</style>